var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle-button',{class:{rotation: _vm.value && _vm.rotate},attrs:{"icon":_vm.icon,"color":_vm.color,"title":_vm.title},on:{"click":_vm.toggle}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c0cac4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CircleToggler.vue
// module id = 1057
// module chunks = 0